<template>
  <Dialog :width="700">
    <template v-slot:button="{ on, attrs }">
      <slot
          name="button"
          :attrs="attrs"
          :on="on"
      />
    </template>

    <template #header>
      <h2>Haben Sie alle Artikel komissioniert, die Sie an Lager haben?</h2>
    </template>

    <template v-slot:actions="{close}">
      <v-btn
          color="beige"
          depressed
          @click="close"
      >
        Abbrechen
      </v-btn>
      <v-btn
          color="primary"
          depressed
          :disabled="isUpdating"
          @click="confirm(close)"
      >
        Bestätigen
      </v-btn>
    </template>

    <div class="mb-8">
      Sie können die abgeschlossenen Aufträge nicht mehr bearbeiten. Es wird eine Einräumliste für die (Teil-) Lieferung
      erstellt.
    </div>
  </Dialog>
</template>

<script>
import Dialog from "@/components/SmartLogistics/Design/Dialog.vue";
import {internalOrderMixin} from "@/mixins/SmartLogistics/ModelC/internalOrder";

export default {
  name: 'PartialDeliveryConfirmationDialog',
  components: {Dialog},
  mixins: [internalOrderMixin],

  methods: {
    confirm(callback) {
      this.$store.dispatch('smartLogisticWarehouse/completePartialDelivery', this.currentlyOpenPartialDelivery.id)
      callback()
    }
  }
}
</script>